import { Validator, Success, Failure, ValidationError } from '@totalsoft/pure-validations';
import { testMobilePhone } from 'utils/simple-validations';
import { areMultipleEmailsValid } from '@totalsoft/validations';
import i18next from 'i18next';
import moment from 'moment';

const defaultMessages = {
  'Validations.Generic.Phone': 'The value is not a valid phone number'
};

function translate(key, args) {
  return i18next.t(key, { defaultValue: defaultMessages[key], ...args }) || defaultMessages[key];
}

export const hasMultipleEmails = Validator(function multipleEmails(content) {
  if (!content) return Success;
  const emails = content.split(';');
  return areMultipleEmailsValid(emails) ? Success : Failure(ValidationError(translate('Validations.Generic.MultipleEmails')));
});

export const isMobilePhoneByCountry = countryCode => {
  return Validator(function isMobilePhoneByCountry(value) {
    return !value || testMobilePhone(value, countryCode) ? Success : Failure(ValidationError(translate('Validations.Generic.Phone')));
  });
};

export const isValidDateFormat = Validator(function validDateFormat(date) {
  if (date === null) return Success;
  const allowedDateFormats = ['DD/MM/YYYY', 'DD.MM.YYYY', 'DD-MM-YYYY'];
  const newDate = moment(date, allowedDateFormats);
  return newDate.isValid() && newDate.isAfter(moment('01.01.1900', allowedDateFormats))
    ? Success
    : Failure(ValidationError(translate('Validations.Generic.InvalidDateFormat')));
});

export const romanianPhone = Validator(function phone(x) {
  const re = /^(07[0-9]{1}[0-9]{1}|02[0-9]{2}|03[0-9]{2}){1}?(\s|\.|)?([0-9]{3}(\s|\.|)){2}$/;
  return re.test(String(x).toLowerCase()) ? Success : Failure(ValidationError(translate('Validations.Generic.Phone')));
});

export const phone = Validator(function phone(x) {
  const re =
    /^((07[0-9]{1}[0-9]{1}){1}?(\s|\.)?([0-9]{3}(\s|\.|)){2})|0090\d{9,10}$|(\+)90\d{9,10}$|0033\d{9,10}$|(\+)33\d{9,10}$|00373\d{9,10}$|(\+)373\d{9,10}$|0039\d{9,10}$|(\+)39\d{9,10}$|0049\d{9,10}$|(\+)49\d{9,10}$/;
  return re.test(String(x).toLowerCase()) ? Success : Failure(ValidationError(translate('Validations.Generic.Phone')));
});

export const isFullPersonName = Validator(function isFullPersonName(x) {
  const re = /\S+/g;
  var matches = String(x).match(re);
  return matches?.length >= 2 ? Success : Failure(ValidationError(translate('Validations.Generic.FullName')));
});

export const noSpaceAtBeginning = Validator(function noSpaceAtBeginning(x) {
  var re = /^[\S0-9a-zA-Z]/;
  var matches = re.test(String(x));
  return matches ? Success : Failure(ValidationError(translate('Validations.Generic.NoSpace')));
});

export const dateIsGreaterThanGivenDate = date =>
  Validator(function dateIsGreaterThanGivenDate(x) {
    if (date && x) {
      return moment(x).isAfter(new Date(date), 'day')
        ? Success
        : Failure(ValidationError(i18next.t('Validations.Generic.Greater', { min: date })));
    }
    return Success;
  });

export const lessOrEqualThan = maxValue =>
  Validator(function isValueLessThanToValidator(value) {
    return value <= maxValue ? Success : Failure(ValidationError(translate('Validations.Generic.LessOrEqual', { max: maxValue })));
  });
